import { Box, Typography, Grid, Chip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import intl from "components/i18n/ReactIntlWrapper";
import { DataGrid, GridColDef, GridInitialState } from '@mui/x-data-grid';
import { useState } from 'react';
import { useApi } from '../../../api/ApiProvider';
import Api from '../../../axiosApi/api';
import { useToastMessageQueue } from 'components/ToastMessages/ToastMessageProvider';
import { handleAPIError } from 'common/errorHandler';
import DefaultActions from 'components/DataGrid/DefaultActions';
import { ENTITY_TYPE } from 'common/constants';
import { useSearch } from "hooks/useSearch";
import { Employee } from "axiosApi/models/employee";
import { useNavigate } from "react-router";
import Spinner from "components/Spinner";

const RequestedTimeOff = () => {
  const api: Api = useApi();
  const toast = useToastMessageQueue();
  const [errors, setErrors] = useState({});

  const apiPromise = (
    searchTerm: string,
    pageNum: number,
    pageSize: number,
    sort: string,
    order: string
  ) => {
    return api.timeoffApi.apiVversionEmployeeTimeOffRequestSearchMineGet("1", pageNum, pageSize, sort, order);
  };

  const navigate = useNavigate();

  const processError = (error: any) => {
    handleAPIError(error, toast, errors);
    setErrors({ ...errors });
  };

  const { data, loading, onPaginationModelChange, handleSortModelChange } = useSearch<Employee>({
    apiPromise: apiPromise,
    searchTerm: "",
    defaultSort: { sort: 'Name', order: 'asc' },
    onError: processError,
  });

  const INITIAL_STATE: GridInitialState = {
    pagination: {
      paginationModel: {
        page: 0,
        pageSize: 10,
      },
    },
  };

  const handleEdit = (data: any) => {
    navigate(`/timeOffRequest/detail/${data.id}`);
    window.location.reload();
  };

  const columns: GridColDef[] = [
    {
      field: 'timeOffTypeName',
      headerName: intl.get('timeOff.type') || 'Type',
      width: 200,
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'workflowStateName',
      headerName: intl.get('timeOff.table.thead.status') || 'Status',
      width: 150,
      renderCell: (params) => {
        const color = params.row.workflowStateColor;
        return (
          <Chip
            color={color}
            className={color === "default" ? "observed" : ""}
            size="small"
            label={params.value}
            sx={{ fontWeight: 500 }}
          />
        );
      },
    },
    {
      field: 'dateRange',
      headerName: intl.get('timeOff.table.thead.dateRange') || 'Date Range',
      width: 200,
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2" color="text.secondary">
          {params.row.from?.split('T')[0]} - {params.row.to?.split('T')[0]}
        </Typography>
      ),
    },
    {
      field: 'actions',
      headerName: '',
      width: 100,
      align: 'center',
      renderCell: (params) => {
          return (
            <DefaultActions
              row={params.row}
              entityType={ENTITY_TYPE.ANY}
              onEdit={() => handleEdit(params.row)}
              editScopes={[]}
            />
          );
      },
    },
  ];

  return (
    <Box>
      {loading && <Spinner />}
      {data?.totalRecords > 0 ? (
        <Box sx={{ width: '100%' }}>
          <DataGrid
            rows={data?.queryResult || []}
            columns={columns}
            rowCount={data?.totalRecords || 0}
            initialState={INITIAL_STATE}
            onPaginationModelChange={onPaginationModelChange}
            onSortModelChange={handleSortModelChange}
          />
        </Box>
      ) : (
        <Grid
          container
          className="my-3 p-3"
          justifyContent="center"
          alignItems="center"
        >
          <InfoIcon
            style={{ height: "2em", width: "2em", color: "#bdbdbd" }}
          />
          <Typography variant="body2" align="center" mt={1}>
            {intl.get("requestedTimeOff.information.label")}
          </Typography>
        </Grid>
      )}
    </Box>
  );
};

export default RequestedTimeOff;
